export const Lahoysk = {
  type: "FeatureCollection",
  features: [
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [27.71287966907613, 54.67681751887801],
            [27.70567748398622, 54.67653033076914],
            [27.700535058379273, 54.6760347762862],
            [27.69453556093964, 54.67520883870759],
            [27.688821754709693, 54.674052497872594],
            [27.68053673477806, 54.671739717413004],
            [27.675679998584428, 54.668600732723576],
            [27.67110895360048, 54.664139653125744],
            [27.664823765849405, 54.660504337533894],
            [27.65653874591783, 54.6542243892838],
            [27.644825442248248, 54.64827406923342],
            [27.6402543972643, 54.64546389275915],
            [27.63711180383791, 54.64133092759846],
            [27.633969209513225, 54.638354932877235],
            [27.62682695172589, 54.63604011919551],
            [27.619113312417255, 54.633890531834254],
            [27.61339950528901, 54.63107936152403],
            [27.61082829248545, 54.629094888495956],
            [27.607685699059118, 54.6252910455446],
            [27.607685699059118, 54.62181766036139],
            [27.607971389370675, 54.616358884772694],
            [27.609685531239677, 54.612388406028685],
            [27.610256911862677, 54.60874846068515],
            [27.607971389370675, 54.60527366321759],
            [27.601400511308043, 54.602791483797205],
            [27.595686704179798, 54.602295029752554],
            [27.587115994835074, 54.60146759289239],
            [27.58140218770683, 54.59848868044003],
            [27.57883097490344, 54.596502618074794],
            [27.57883097490344, 54.5935233423848],
            [27.577973903968882, 54.590378315475846],
            [27.56883181310286, 54.587895227431716],
            [27.56226093504023, 54.5865708521938],
            [27.557404199744667, 54.58524643389984],
            [27.549690560436034, 54.5832597252068],
            [27.5431196823734, 54.58127292015422],
            [27.53797725676668, 54.57878927759754],
            [27.532263449638435, 54.57613989149149],
            [27.5239784297068, 54.575477518181856],
            [27.518550313788467, 54.575146327489904],
            [27.51226512603722, 54.574815134106814],
            [27.502265964236642, 54.573655936070736],
            [27.495695087072306, 54.57216549015027],
            [27.48940989932123, 54.5691844342802],
            [27.48512454464867, 54.56736257090773],
            [27.48026780845504, 54.56520935415455],
            [27.471125717589018, 54.564049882924735],
            [27.462269317034384, 54.56355295658966],
            [27.45626982049305, 54.562559085749626],
            [27.450841703676247, 54.5609025805137],
            [27.447127729626857, 54.55775503464321],
            [27.447984800561414, 54.55228766740299],
            [27.448556181184415, 54.54764811429368],
            [27.448556181184415, 54.543670934938746],
            [27.442556683744613, 54.53936188593383],
            [27.44084254187578, 54.533560524646305],
            [27.441128232187225, 54.5295819715609],
            [27.443985136200467, 54.52576882814799],
            [27.450841703676247, 54.52228695086245],
            [27.455698439870048, 54.51946807125307],
            [27.46369776859177, 54.51681482981962],
            [27.470268646654404, 54.5158198200387],
            [27.47598245378265, 54.51598565668553],
            [27.482839021258428, 54.516151492659105],
            [27.488552828386673, 54.51598565668553],
            [27.493695253993565, 54.513829727757695],
            [27.49883768049864, 54.51051269129675],
            [27.504551486728587, 54.5078588686153],
            [27.506551319807443, 54.506200141377235],
            [27.506837010118886, 54.50188713675766],
            [27.506265629495886, 54.49773958709221],
            [27.5042657964172, 54.49525085556519],
            [27.49998044174481, 54.49176637632422],
            [27.497123538629864, 54.49010699634857],
            [27.49626646769525, 54.48313686389139],
            [27.49798060956425, 54.4793193836619],
            [27.500266132056254, 54.47566754686909],
            [27.50055182236764, 54.46803083508155],
            [27.49998044174481, 54.46006057247058],
            [27.495123706449306, 54.459064180038354],
            [27.490552660567232, 54.458067763872066],
            [27.48626730589467, 54.45657309414133],
            [27.482267640635598, 54.454414030398254],
            [27.481696260012598, 54.44909892627254],
            [27.484267472815986, 54.445942756500585],
            [27.489695589632618, 54.44444764405148],
            [27.49312387337062, 54.44444764405148],
            [27.497694919252865, 54.444613770352646],
            [27.50112320299064, 54.444613770352646],
            [27.503980106105587, 54.44295247701632],
            [27.505122868249885, 54.44012812315799],
            [27.5031230351712, 54.43663894719401],
            [27.498266299875638, 54.43431266424125],
            [27.495123706449306, 54.431155355362364],
            [27.49140973150162, 54.42733302380691],
            [27.488552828386673, 54.424341385060245],
            [27.48455316402567, 54.422845484049674],
            [27.479982118143596, 54.422679269455955],
            [27.476839524717093, 54.42467380061487],
            [27.476268144094092, 54.426335835331486],
            [27.47455400222526, 54.42833018801696],
            [27.470554336966018, 54.42783160894527],
            [27.46712605322807, 54.426668234186025],
            [27.46484053073607, 54.424341385060245],
            [27.463983458903385, 54.42085086443518],
            [27.460269484853825, 54.41636261486633],
            [27.456555510804435, 54.4140351811468],
            [27.45598413018149, 54.410710046099325],
            [27.45741258173905, 54.4065532481963],
            [27.462840697657384, 54.403560093165424],
            [27.46969726603146, 54.40123193266942],
            [27.475696763471262, 54.39956887945391],
            [27.479982118143596, 54.393581330937366],
            [27.48998127994406, 54.38659475322828],
            [27.49883768049864, 54.38193637370722],
            [27.5042657964172, 54.37844224247897],
            [27.507694081053444, 54.3762790592894],
            [27.509408222922275, 54.37311727958968],
            [27.508265461676274, 54.368290935349876],
            [27.506551319807443, 54.36596077328761],
            [27.501408893302198, 54.36329756851927],
            [27.497123538629864, 54.3622988224073],
            [27.49255249274762, 54.3599683203733],
            [27.49140973150162, 54.356805284179245],
            [27.49255249274762, 54.35414148630434],
            [27.495123706449306, 54.352143524037615],
            [27.496552158006864, 54.34848034185711],
            [27.497123538629864, 54.34498336281973],
            [27.496552158006864, 54.34115299681099],
            [27.494552325826305, 54.33682258863246],
            [27.493695253993565, 54.333324617738356],
            [27.49626646769525, 54.32749400529468],
            [27.49740922894125, 54.32149594149399],
            [27.493695253993565, 54.318496581864736],
            [27.488552828386673, 54.315996947942836],
            [27.488552828386673, 54.312330543737346],
            [27.490552660567232, 54.30949718987148],
            [27.494266634616565, 54.307330375882316],
            [27.498266299875638, 54.30449667724707],
            [27.49683784831825, 54.30082924892997],
            [27.49312387337062, 54.29882869525062],
            [27.48826713807523, 54.29849526027374],
            [27.481696260012598, 54.29882869525062],
            [27.47712521502865, 54.30082924892997],
            [27.472839859457792, 54.30332980367649],
            [27.46969726603146, 54.30533013811845],
            [27.465126221047683, 54.3084971360513],
            [27.461983626722827, 54.3089971659989],
            [27.45626982049305, 54.30833045805207],
            [27.45198446492219, 54.30666364093594],
            [27.449413252118802, 54.30332980367649],
            [27.447984800561414, 54.297995102745745],
            [27.443128064367784, 54.29516076198951],
            [27.440556851564224, 54.29349341105927],
            [27.437128567826278, 54.291492501457924],
            [27.434843045334446, 54.288324195239284],
            [27.434271664711446, 54.28432177651001],
            [27.436557187203277, 54.28031896835205],
            [27.435985806580277, 54.27698299823072],
            [27.43398597439989, 54.27431402714092],
            [27.428843547894644, 54.272645832753994],
            [27.419130076405622, 54.26964291216291],
            [27.413416269277377, 54.267640843898846],
            [27.41055936616243, 54.2644707030754],
            [27.4099879855396, 54.260465966853644],
            [27.41055936616243, 54.25662772907907],
            [27.408559533982043, 54.25412433838454],
            [27.402768464442374, 54.252432754431766],
            [27.404514158847974, 54.249651234937744],
            [27.40780531116451, 54.247941980363976],
            [27.41511255623186, 54.2464671912021],
            [27.42136203235725, 54.2475104826583],
            [27.428950681873857, 54.24881456026759],
            [27.434753767168274, 54.25037939876921],
            [27.44368159007604, 54.250640199764234],
            [27.45171663042379, 54.248032118754224],
            [27.45260941298403, 54.24542387335981],
            [27.45260941298403, 54.23994602033724],
            [27.450377457032403, 54.23290199788147],
            [27.4454671542984, 54.22951000310786],
            [27.441449634124467, 54.22481293399392],
            [27.444127980907012, 54.22246419928234],
            [27.449038283641073, 54.22220322068608],
            [27.457073323988766, 54.22533485707095],
            [27.463322800114213, 54.22951000310786],
            [27.46734032118627, 54.23420653727527],
            [27.46912588540846, 54.239424281992456],
            [27.472697014751418, 54.244380528606484],
            [27.480732055098997, 54.2464671912021],
            [27.485642357833, 54.2464671912021],
            [27.49010626973609, 54.2441196885577],
            [27.486981531224387, 54.24020688677325],
            [27.485195967002028, 54.236293714434055],
            [27.486535140393414, 54.233162909374016],
            [27.49233822568766, 54.23029279591424],
            [27.49680213669245, 54.22872719545643],
            [27.497248527523425, 54.22455197024374],
            [27.490999051397978, 54.22037632274754],
            [27.482517620219483, 54.21750532019149],
            [27.474036188142634, 54.21437308993802],
            [27.470018667968873, 54.210196413040194],
            [27.470465058799846, 54.20836898441627],
            [27.474482578973607, 54.20654147442423],
            [27.478500099147368, 54.20575823125807],
            [27.486552996206285, 54.20452589860258],
            [27.490266970255618, 54.20452589860258],
            [27.49198111212462, 54.202353561822804],
            [27.49198111212462, 54.19901128168874],
            [27.494266634616565, 54.19683865497302],
            [27.499694751433253, 54.19483305200879],
            [27.50912253261083, 54.193997354856435],
            [27.514550648529166, 54.19383021350342],
            [27.5216929072148, 54.19149016359137],
            [27.5262639530971, 54.18898282024577],
            [27.530263617457877, 54.187645507750176],
            [27.53740587614368, 54.18647532428969],
            [27.546833657321258, 54.18664249538335],
            [27.55768989005628, 54.18747834071229],
            [27.565403529364914, 54.18998577583386],
            [27.572260096840807, 54.19215876279861],
            [27.57940235552644, 54.193997354856435],
            [27.58797306576946, 54.19466591403511],
            [27.595115323556797, 54.19199161401065],
            [27.59254411075341, 54.18931714147885],
            [27.586544614212073, 54.18413485800312],
            [27.58311632957583, 54.17895192491949],
            [27.583973400510217, 54.17443722801164],
            [27.583402019887217, 54.169085838028195],
            [27.57825959428044, 54.166075377221375],
            [27.576545452411494, 54.1625628955523],
            [27.57683114272288, 54.15570433436238],
            [27.57683114272288, 54.149011959707764],
            [27.573117167775195, 54.14315524425007],
            [27.56883181310286, 54.140644969959226],
            [27.56711767123386, 54.13629346685275],
            [27.569117503414247, 54.12943055252026],
            [27.57083164528325, 54.12574754414044],
            [27.573117167775195, 54.12139447587742],
            [27.572831477463637, 54.115868769301926],
            [27.57397423870964, 54.10916995556158],
            [27.57397423870964, 54.10414513474575],
            [27.57568838147688, 54.098784654727865],
            [27.57883097490344, 54.09325593455958],
            [27.58511616175622, 54.08554800312868],
            [27.587687375458074, 54.079682313696196],
            [27.58940151732685, 54.0770005797861],
            [27.592829801064852, 54.07448629636127],
            [27.59911498881604, 54.07230712800117],
            [27.60282896286543, 54.07012784525472],
            [27.606542937813117, 54.06711018746546],
            [27.608542769993676, 54.06409231089373],
            [27.611685363420065, 54.05990045128959],
            [27.6159707180924, 54.05654665887994],
            [27.621113144597643, 54.05268946345592],
            [27.62654126141433, 54.05185089532256],
            [27.6396830166413, 54.05168317966485],
            [27.646253893805635, 54.05369572287515],
            [27.651682010622437, 54.055708168599324],
            [27.657110127439125, 54.05939739976935],
            [27.65882426930807, 54.062750961492384],
            [27.661109791800072, 54.06811609758688],
            [27.661109791800072, 54.07247476039748],
            [27.65882426930807, 54.08269905777638],
            [27.659681340242457, 54.08571558205881],
            [27.653681842802825, 54.08722376250279],
            [27.646253893805635, 54.08621831478837],
            [27.640540087575857, 54.08554800312868],
            [27.631683687021223, 54.08571558205881],
            [27.62454142833559, 54.088061616549055],
            [27.619970383351642, 54.091747973369195],
            [27.618827622105698, 54.0989521801996],
            [27.619113312417255, 54.102302548069474],
            [27.623112976778202, 54.10565264529578],
            [27.630255235463835, 54.10649012718386],
            [27.635397661070613, 54.10649012718386],
            [27.64225422944486, 54.10665762153167],
            [27.64882510750749, 54.10766257341089],
            [27.652539081556824, 54.107160100515955],
            [27.65653874591783, 54.104815145966484],
            [27.66082410148846, 54.1029725890607],
            [27.66510945616085, 54.10146498160708],
            [27.667680669862534, 54.10062739822911],
            [27.669680502043093, 54.09694182988028],
            [27.673394476092426, 54.0945962980241],
            [27.677679831663283, 54.09509892315816],
            [27.682536566958447, 54.09710936279515],
            [27.68539347007345, 54.09911970552139],
            [27.689678825644307, 54.10146498160708],
            [27.696821083431587, 54.10364261922609],
            [27.70139212931366, 54.103810125075825],
            [27.706820245232223, 54.10314009761686],
            [27.712819742671854, 54.10247005933212],
            [27.7162480264098, 54.10029236014151],
            [27.717676478865542, 54.09493138212338],
            [27.7179621691771, 54.09023995789369],
            [27.719390620734487, 54.088061616549055],
            [27.722818904472263, 54.08705618913643],
            [27.72881840191212, 54.08655346655786],
            [27.733675137207456, 54.08672104142755],
            [27.741674466827476, 54.088061616549055],
            [27.74767396336881, 54.088396753430516],
            [27.753387770497056, 54.08688861562047],
            [27.756530363923616, 54.085045262278356],
            [27.75995864855969, 54.08269905777638],
            [27.761958480740304, 54.08068791924455],
            [27.765101074166637, 54.07767102950669],
            [27.77024350067188, 54.075994884901036],
            [27.77338609409827, 54.07582726671785],
            [27.77795713908222, 54.075994884901036],
            [27.782813875275906, 54.07800625030626],
            [27.78652784932524, 54.08085551780039],
            [27.788813372715538, 54.08336941545491],
            [27.790813204895926, 54.0848776806414],
            [27.793955798322486, 54.086050737888684],
            [27.795955630502874, 54.08621831478837],
            [27.79771835465459, 54.086333198531975],
            [27.799383915139117, 54.09191552726065],
            [27.801955127942506, 54.09861712857952],
            [27.805097721369066, 54.1029725890607],
            [27.813954121923473, 54.1073275921575],
            [27.830238471475298, 54.10783006302279],
            [27.837380729262634, 54.1073275921575],
            [27.849094032932214, 54.10783006302279],
            [27.850236795076512, 54.112017083965725],
            [27.846522820128655, 54.1136917737378],
            [27.84309453639088, 54.116538591089466],
            [27.837952109885634, 54.11955265571504],
            [27.836523658328247, 54.12306878734108],
            [27.836809348639633, 54.12926315017478],
            [27.84052332358732, 54.13160672146154],
            [27.849094032932214, 54.1327784573906],
            [27.861093027811535, 54.13010015513879],
            [27.86537838248387, 54.12675203329553],
            [27.86909235653343, 54.12474303063374],
            [27.88051997078975, 54.12306878734108],
            [27.88623377701947, 54.12306878734108],
            [27.896518629131663, 54.12306878734108],
            [27.904803649063297, 54.12306878734108],
            [27.909374694047074, 54.12273393003886],
            [27.914802810863875, 54.118380545721266],
            [27.91508850117532, 54.1136917737378],
            [27.917088333355878, 54.11084476034512],
            [27.92165937923795, 54.10950492193069],
            [27.927944566090844, 54.10950492193069],
            [27.93422975384209, 54.10933743908441],
            [27.94222908346211, 54.10649012718386],
            [27.950799793705187, 54.101297466284564],
            [27.960798955505936, 54.09761195747973],
            [27.968512593916103, 54.09493138212338],
            [27.977083304159294, 54.09292083639991],
            [27.983939872533313, 54.09124530763421],
            [27.99051074969765, 54.090742635808965],
            [27.99765300838351, 54.09124530763421],
            [28.000509911498284, 54.09426121121794],
            [28.001081292121285, 54.098784654727865],
            [28.00308112520014, 54.102302548069474],
            [28.007366479872474, 54.106155136458426],
            [28.010223382987476, 54.10883498648633],
            [28.009937692675862, 54.112686967992886],
            [28.005366647691915, 54.115868769301926],
            [27.997367318071895, 54.118380545721266],
            [27.98965367876326, 54.12139447587742],
            [27.981654350041538, 54.125077871174994],
            [27.974512091355905, 54.129765355182315],
            [27.97222656886396, 54.1361260922385],
            [27.97222656886396, 54.14248585265119],
            [27.975940542913293, 54.146836705153646],
            [27.97936882665124, 54.15085247045067],
            [27.985368324090928, 54.154867846764944],
            [27.987368156271316, 54.160722905477485],
            [27.99051074969765, 54.165740868053945],
            [27.998795769629453, 54.17092545676627],
            [28.011937525754774, 54.173266670723365],
            [28.020222544788055, 54.173768342188964],
            [28.026793422850687, 54.171928850402026],
            [28.031650159044375, 54.171092690728926],
            [28.03707827496271, 54.17209608030839],
            [28.042792082090955, 54.17711266366172],
            [28.037935345897267, 54.18313176046507],
            [28.03393568153632, 54.185472283532704],
            [28.02850756471969, 54.18965146000818],
            [28.02793618409669, 54.19433163606038],
            [28.030793087211464, 54.198342793326276],
            [28.038506726520268, 54.20051534149218],
            [28.04822019800929, 54.20201934602699],
            [28.058505050121312, 54.20486009412383],
            [28.069361282856505, 54.207867732695945],
            [28.075360780296137, 54.20920439043476],
            [28.08564563240816, 54.21070807869404],
            [28.091645128949494, 54.21087515178857],
            [28.100787219815686, 54.20903731058257],
            [28.105072575386373, 54.205528477056646],
            [28.105072575386373, 54.202353561822804],
            [28.10650102694376, 54.19466591403511],
            [28.10792947850132, 54.19316164133227],
            [28.111357762239265, 54.19182446454681],
            [28.117928640301898, 54.19165731440705],
            [28.122785376495585, 54.19282735119128],
            [28.12649935054492, 54.195668731738465],
            [28.13021332459448, 54.19533446187427],
            [28.132784537397868, 54.19299449659974],
            [28.133355918919165, 54.18931714147885],
            [28.13364160923055, 54.18580663315555],
            [28.135070060788166, 54.18129268458222],
            [28.13735558328011, 54.179453527429814],
            [28.141355247640888, 54.18112549185747],
            [28.145640603211575, 54.18597380695303],
            [28.148783196638135, 54.18981861825898],
            [28.15392562314321, 54.193495928769664],
            [28.159925119684544, 54.19667152511005],
            [28.167638758993178, 54.199846876934885],
            [28.17563808861337, 54.20285488044783],
            [28.186208631036948, 54.20569557110031],
            [28.195636412214583, 54.20903731058257],
            [28.20934954806455, 54.21555292460391],
            [28.218491638930573, 54.21872682604209],
            [28.230112241028394, 54.22251890931045],
            [28.226490968550763, 54.22524091160352],
            [28.229062181354152, 54.23342381869219],
            [28.2330618457151, 54.241271205475925],
            [28.237918581908787, 54.2469471084126],
            [28.243061007515678, 54.25412433838454],
            [28.246489292151978, 54.260132221275796],
            [28.249631885578367, 54.2644707030754],
            [28.255060002395, 54.26697346620102],
            [28.260202428001946, 54.26997658075271],
            [28.261345189247947, 54.276816192110346],
            [28.261345189247947, 54.28382144682445],
            [28.261345189247947, 54.28899122774283],
            [28.258488286132945, 54.29616113982837],
            [28.2533458596277, 54.29782838221945],
            [28.245346530905977, 54.29749493914204],
            [28.240775485023732, 54.296828044885785],
            [28.232776155403542, 54.29632786710533],
            [28.223919754849078, 54.29716149336406],
            [28.219063019553573, 54.2991621275271],
            [28.220205780799517, 54.30232960000393],
            [28.22734803948515, 54.30516344729426],
            [28.23163339415771, 54.3084971360513],
            [28.229633561977153, 54.31366381976079],
            [28.223919754849078, 54.315497003040264],
            [28.21677749706174, 54.31333050493561],
            [28.21134938024494, 54.31199721811299],
            [28.206778335261163, 54.31083055716613],
            [28.20220728937892, 54.31083055716613],
            [28.19820762501797, 54.316330241169965],
            [28.19763624439497, 54.31899649032158],
            [28.19763624439497, 54.321829190177255],
            [28.193065198512727, 54.32532813889202],
            [28.18678001165995, 54.32749400529468],
            [28.179637752974315, 54.32816040278175],
            [28.167067378370348, 54.32566135653127],
            [28.16563892681279, 54.32232905814044],
            [28.163924784943788, 54.318496581864736],
            [28.157639597192713, 54.315663652016156],
            [28.15335424252038, 54.315663652016156],
            [28.146783364457576, 54.315996947942836],
            [28.14192662826389, 54.31816330566164],
            [28.142783699198446, 54.32149594149399],
            [28.14792612570352, 54.32466169551543],
            [28.15278286099891, 54.3294931653636],
            [28.154497003766153, 54.334324068209355],
            [28.155068384389153, 54.33882129523977],
            [28.158210977815713, 54.344483770171564],
            [28.161353571242103, 54.34981244588539],
            [28.166495997747347, 54.35147751520145],
            [28.173923946744367, 54.35264302358104],
            [28.179923443285702, 54.3554734068295],
            [28.183923108545002, 54.35930243784105],
            [28.18792277290595, 54.36446274162461],
            [28.194207960656968, 54.36945596680391],
            [28.201635908755918, 54.37777665995225],
            [28.20592126432655, 54.382601888791896],
            [28.213634902736885, 54.38609566648216],
            [28.22306268391452, 54.38825833188196],
            [28.22791942010815, 54.38909009592044],
            [28.234490298170783, 54.39158528740745],
            [28.240775485023732, 54.39690785489819],
            [28.24220393658129, 54.399735187757244],
            [28.239918414089345, 54.40422525760613],
            [28.236490130351342, 54.4072183646162],
            [28.236490130351342, 54.41137509457752],
            [28.23906134315473, 54.4140351811468],
            [28.24277531720412, 54.41952106409809],
            [28.243918078450122, 54.42367654690736],
            [28.239918414089345, 54.426834432602504],
            [28.2336332263381, 54.42866257069477],
            [28.21734887768457, 54.43248477823033],
            [28.201921599067475, 54.433315645617824],
            [28.183923108545002, 54.435309658601],
            [28.170495662108294, 54.43647278854394],
            [28.158496668127157, 54.438300496625004],
            [28.154497003766153, 54.44245407587408],
            [28.153639932831766, 54.44610887673656],
            [28.15106871913008, 54.45092607096552],
            [28.146497674146133, 54.45657309414133],
            [28.1393554154605, 54.46205328352289],
            [28.13135608584031, 54.46670256586498],
            [28.12564227961053, 54.47052122364801],
            [28.11592880812134, 54.47467153493625],
            [28.110500691304708, 54.47815747112327],
            [28.105643956009317, 54.48147713366296],
            [28.101929981061517, 54.487451847769876],
            [28.101644290750073, 54.49027293737714],
            [28.099073077946684, 54.49691002675354],
            [28.09307358140535, 54.49973046321088],
            [28.081074586525915, 54.50055996630488],
            [28.071932495659894, 54.500394067032914],
            [28.063933166937943, 54.502218922506074],
            [28.06164764354787, 54.506200141377235],
            [28.05936212105587, 54.5121712429343],
            [28.052791243891534, 54.51698066242648],
            [28.045363294894344, 54.52245276125046],
            [28.03822103620871, 54.52875305763604],
            [28.034792752470764, 54.533560524646305],
            [28.030221706588463, 54.53969336735679],
            [28.02707911316213, 54.5458252885482],
            [28.02479359067013, 54.5516249064824],
            [28.020222544788055, 54.55609833424518],
            [28.01422304824672, 54.558417695958724],
            [28.00679509924953, 54.559742986286835],
            [27.996510247137508, 54.564049882924735],
            [27.993653344022505, 54.56785945081134],
            [27.994796105268506, 54.57299352239039],
            [27.998224389006282, 54.57763019259784],
            [28.00193836395414, 54.58143849094222],
            [28.006509408938086, 54.58574309580575],
            [28.006580908697458, 54.58581215004625],
            [28.00476120596494, 54.58897551930488],
            [28.002471598585544, 54.594613542780905],
            [27.99731998153203, 54.600250785645414],
            [27.989878757998326, 54.60224021461437],
            [27.980147925286644, 54.6032348926762],
            [27.96984469207905, 54.6048926345876],
            [27.95782425288712, 54.6032348926762],
            [27.9458038145944, 54.6009139394269],
            [27.936645384177325, 54.599256034738346],
            [27.91947332793177, 54.599256034738346],
            [27.90745288874001, 54.6015770824165],
            [27.902301272585703, 54.606218781172004],
            [27.901728870291265, 54.61318033600378],
            [27.898294459221916, 54.61947786021523],
            [27.89314284216846, 54.626105780057856],
            [27.886274020029987, 54.627431234164135],
            [27.881694805271138, 54.62643714785611],
            [27.87310877714839, 54.622129157834536],
            [27.866239955010087, 54.61550058958062],
            [27.862805543940794, 54.612848860286704],
            [27.85650912319761, 54.60986545832441],
            [27.841626675230998, 54.61019695832306],
            [27.83075103972874, 54.609533955627626],
            [27.821592609311494, 54.60555571372532],
            [27.813578983483353, 54.60224021461437],
            [27.80556535765521, 54.60190864986447],
            [27.789538105099496, 54.60224021461437],
            [27.778090068202175, 54.60522417505575],
            [27.77637286221784, 54.608539431349755],
            [27.769504040079426, 54.61417474696714],
            [27.767214432699973, 54.62080353015898],
            [27.76378002163085, 54.63107601104906],
            [27.76034560966218, 54.636045634998084],
            [27.756911198593002, 54.643002088875335],
            [27.750042376454587, 54.646976670537015],
            [27.74145634833195, 54.6496261758075],
            [27.732870320209145, 54.65326896339212],
            [27.723711890691277, 54.657573655599776],
            [27.715698264863136, 54.66386430809132],
            [27.714553460274033, 54.6721399990617],
            [27.71287966907613, 54.67681751887801],
          ],
        ],
      },
      properties: {
        shapeName: "Lahoysk",
        shapeISO: "",
        shapeID: "67162791B73059269727639",
        shapeGroup: "BLR",
        shapeType: "ADM2",
      },
    },
  ],
};
